import * as Phaser from 'phaser';
import { renderEmptyStateTab } from './emptyStateRenderer';
import type { JournalTabState } from './journalDispatch';

export function renderExpeditionLogTab(
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  state: JournalTabState,
): void {
  renderEmptyStateTab(scene, container, state);
}
